module.exports = __webpack_public_path__ + "img/car-21.f82c3fde.jpg";